<template>
<div id="app">
    <logo></logo>
    <div class="buttons">
        <router-link class="additionalButtons" to="/">Alat</router-link>
        <router-link class="additionalButtons" to="/fondovi"><img src="./assets/EUlogo.jpg" /> Zajedno do EU fondova!</router-link>
        <router-link class="additionalButtons" to="/clanak">O alatu</router-link>
    </div>
    <router-view></router-view>
</div>
</template>

<script>
import Logo from './components/Logo.vue'

export default {
    name: 'App',
    components: {
        Logo,
    }
}
</script>

<style lang="scss">
@import "/src/scss/main.scss";

#app {
    font: normal 18px/1.5 "Fira Sans", "Helvetica Neue", sans-serif;
    padding-bottom: 60px;
    width: 100%;
}
</style>
